"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResult = parseResult;
exports.calculateFan = calculateFan;
exports.setPropertiesInput = setPropertiesInput;
exports.setPropertiesFromFile = setPropertiesFromFile;
exports.addFanCurvePoint = addFanCurvePoint;
exports.deleteFanCurvePoint = deleteFanCurvePoint;
function parseResult(result) {
    return {
        type: "fan-pro-tool/PARSE-RESULT",
        result: result
    };
}
function calculateFan(screen) {
    return {
        type: "fan-pro-tool/CALCULATE-FAN",
        payload: screen
    };
}
function setPropertiesInput(pvs) {
    return {
        type: "fan-pro-tool/SET-PROPERTIES-AIR-IN",
        payload: pvs
    };
}
function setPropertiesFromFile(pvses) {
    return {
        type: "fan-pro-tool/SET-PROPERTIES-FROM-FILE",
        payload: { pvses }
    };
}
function addFanCurvePoint() {
    return {
        type: "fan-pro-tool/ADD-FAN-CURVE-POINT"
    };
}
function deleteFanCurvePoint() {
    return {
        type: "fan-pro-tool/DELETE-FAN-CURVE-POINT"
    };
}
//# sourceMappingURL=actions.js.map